import styled from 'styled-components';
import { Divider } from '@mui/material';

import colors from '../../../../styles/colors';

const Container = styled.div`
  display: flex;
  flex-direction: row;
  padding: 15px;
  margin-right: 10px;
  align-items: flex-end;
  justify-content: space-between;
  border-radius: 5px;
  flex: 1;
  background-color: ${colors.base.alpha};
`;

const TitleText = styled.div`
  font-size: 12px;
  font-weight: 500;
  line-height: 14px;
`;

const UnitLabel = styled.div`
  font-size: 8px;
  line-height: 10px;
  font-weight: 500;
  margin-top: 2px;
  color: ${colors.shades.secondary8};
`;

const ValueText = styled.div`
  font-size: 24px;
  line-height: 26px;
  font-weight: 800;
  margin-top: 2px;
  color: ${({ $secondary = false }) => ($secondary ? colors.shades.secondary8 : colors.shades.primary1)};
`;

const BaseMacroValueText = styled.div`
  line-height: 14px;
  font-weight: 500;
  margin-top: 2px;
  font-size: 13px;
  color: ${({ $secondary = false }) => ($secondary ? colors.shades.secondary8 : colors.shades.primary1)};
`;

const MacroValueText = styled(BaseMacroValueText)`
  font-size: 11px;
  color: ${({ $secondary = false }) => ($secondary ? colors.shades.secondary8 : colors.shades.primary1)};
`;

const MacroLabelText = styled.div`
  font-size: 10px;
  line-height: 12px;
  font-weight: 400;
  color: ${({ $secondary = false }) => ($secondary === 'popup' ? colors.base.beta : colors.shades.gamma2)};
  margin-top: 2px;
`;
const MacroTitleContainer = styled.div`
  font-size: 12px;
  line-height: 14px;
  margin: 5px 10px;
`;

const MacroTitleText = styled.span`
  margin-right: 5px;
  font-weight: ${($bold) => ($bold ? '500' : '100')};
`;

const AverageStatContainer = styled.div`
  display: flex;
  flex-direction: column;
  font-weight: 500;
  width: 100%;
  padding: 10px;
  margin: 0 10px;
  justify-content: space-between;
`;

const StatContainer = styled.div`
  display: flex;
  flex-direction: row;
  font-weight: 500;
  width: 100%;
  padding: 10px 0;
  justify-content: space-between;
  border-bottom: 1px solid ${colors.shades.gamma5};
`;

const MacroStatContainer = styled.div`
  display: flex;
  flex-direction: column;
  font-weight: 500;
  width: 100%;
  padding: 10px 0px;
  justify-content: space-between;
`;

const MacroStat = styled.div`
  display: flex;
  flex-direction: row;
  width: 100%;
`;

const Stat = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  border-radius: 10px;
  margin: 2px 10px;
`;

const DailyStat = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  border-radius: 10px;
  margin: 2px 10px;
`;

const DailyPopupContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  padding: 10px 20px;
  background-color: ${colors.base.secondary3};
  border-radius: 10px;
  color: ${colors.base.secondary2};
  z-index: 999;
`;

const StyledDivider = styled(Divider)`
  margin: 10px 0;
`;

export {
  Container,
  TitleText,
  UnitLabel,
  ValueText,
  StatContainer,
  Stat,
  AverageStatContainer,
  MacroStatContainer,
  MacroStat,
  MacroLabelText,
  BaseMacroValueText,
  MacroTitleText,
  DailyPopupContainer,
  StyledDivider,
  DailyStat,
  MacroTitleContainer,
  MacroValueText,
};
